import { render } from "./ModalApplyForWfh.vue?vue&type=template&id=04614e4a"
import script from "./ModalApplyForWfh.vue?vue&type=script&lang=js"
export * from "./ModalApplyForWfh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__